import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'BULK_EDIT_CONFIRM_DIALOG';

// Callers are responsible for checking the `showMultiEditAlert` preference before dispatching.
export const showBulkEditConfirmDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ count, hasSplitTxns, onConfirm, onCancel, onDontShowAgain }) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    // fixed id: the root-ui reducer ignores a dialog whose id is already on screen,
    // so a double-click on Save cannot stack two of these
    id: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      count,
      hasSplitTxns,
      onConfirm,
      onCancel,
      onDontShowAgain,
    }),
  }),
);
